import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ApiService } from '../../../Components/Services/apiServices';
import Skeleton from 'react-loading-skeleton';

const HomeService = () => {

    const [services, setServices] = useState("");
    const [loading, setLoading] = useState(false);


    useEffect(() => {

        const fetchtesservices = async () => {
            try {
                setLoading(true);
                const servicesData = await ApiService.Commanfetchrequest('services');
                setServices(servicesData.slice(0, 3));
                console.log('services data:', servicesData);
            } catch (error) {
                console.log('error while fetching:', error);
            } finally {
                setLoading(false);
            }
        }


        fetchtesservices();
    }, []);


    return (
        <>

            {loading ? (
                <>
                    <div className="container-xxl py-5">
                        <div className="container">
                            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                                <h6 className="section-title text-center text-primary text-uppercase"><Skeleton width={50} height={20} /></h6>
                                <h1 className="mb-5"><Skeleton width={50} height={20} /></h1>
                            </div>
                            <div className="row g-4">
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <div key={index} className="col-lg-4 col-md-6">
                                        <div className="service-item rounded">
                                            <div className="service-icon bg-transparent border rounded p-1">
                                                <Skeleton width={60} height={60} />
                                            </div>
                                            <h5 className="mb-3"><Skeleton width={150} height={20} /></h5>
                                            <p className="text-body mb-0"><Skeleton width="100%" height={60} /></p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className='container text-center'>
                        <Link to="/services" className='btn btn text-center'><Skeleton width={160} height={60} /></Link>
                    </div>
                </>
            ) : (
                <>
                    <div className="container-xxl py-5">
                        <div className="container">
                            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                                <h6 className="section-title text-center text-primary text-uppercase">Our Services</h6>
                                <h1 className="mb-5">Explore Our <span className="text-primary text-uppercase">Services</span></h1>
                            </div>
                            <div className="row g-4">
                                {services.length > 0 ? (
                                    services.map((service, index) => (
                                        <div key={index} className="col-lg-4 col-md-6">
                                            <Link to={`/service/${service.services_url}`} className="service-item rounded" style={{ textDecoration: "none" }}>
                                                <div className="service-icon bg-transparent border rounded p-1">
                                                    <div className="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                                                        {service.services_image ? (
                                                            <img src={`https://yourimageurl.com/${service.services_image}`} alt={service.title} className="img-fluid" />
                                                        ) : (
                                                            <i className="fa fa-hotel fa-2x text-primary" />
                                                        )}
                                                    </div>
                                                </div>
                                                <h5 className="mb-3">{service.title}</h5>
                                                <p className="text-body mb-0" dangerouslySetInnerHTML={{ __html: service.description }} />
                                            </Link>
                                        </div>
                                    ))
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='container text-center'>
                        <Link to="/services" className='btn btn-primary text-center'>Explore More Services</Link>
                    </div>
                </>
            )}


        </>
    )
}

export default HomeService
